// extracted by mini-css-extract-plugin
export default {"footer":"InviteRetailerModal_footer__6pvD+"};